"use client";

import type { Locale } from "@/i18n/routing";
import type { AdSize } from "@dafiti/ads-sdk";
import { AdSlot, AdsContainer } from "@dafiti/ads-sdk";
import { cn } from "@dafiti/closet-ui/utils";
import { useLocale } from "next-intl";
import { useEnvContext } from "next-runtime-env";

type AdSlotDef = {
  id: string;
  size: AdSize;
  className?: string;
};

// Contagem/breakpoints de slots são decisão de produto por mercado, não do SDK.
// BR e CO usam o mesmo layout (mobile=2, lg=5, xl=7), mudando só o id da conta GAM.
const AD_ACCOUNT_BY_LOCALE: Record<Locale, string> = {
  "pt-BR": "5917491",
  "es-CO": "8006634",
};

const AD_SLOTS: AdSlotDef[] = [
  { id: "2", size: "medium_rectangle" },
  { id: "3", size: "medium_rectangle" },
  { id: "4", size: "medium_rectangle", className: "hidden lg:block" },
  { id: "7", size: "medium_rectangle", className: "hidden xl:block" },
  { id: "8", size: "medium_rectangle", className: "hidden xl:block" },
  { id: "9", size: "medium_rectangle", className: "hidden lg:block" },
  { id: "1", size: "leaderboard", className: "hidden lg:block" },
];

export function AdsPlacement() {
  const { NEXT_PUBLIC_ADS_UNIT = "" } = useEnvContext();
  const locale = useLocale();

  if (!NEXT_PUBLIC_ADS_UNIT) return null;

  return (
    <aside className={cn("flex w-full justify-center mt-4 lg:mt-8")}>
      <AdsContainer className="-mx-4 md:mx-0 md:w-full md:max-w-[var(--container-md)] lg:max-w-[var(--container-lg)] xl:max-w-[var(--container-xl)] 2xl:max-w-[var(--container-2xl)]">
        {AD_SLOTS.map(({ id, size, className }) => {
          const slot = `div-gpt-ad-${AD_ACCOUNT_BY_LOCALE[locale]}-${id}`;

          return (
            <AdSlot
              key={slot}
              slot={slot}
              unit={NEXT_PUBLIC_ADS_UNIT}
              size={size}
              className={className}
            />
          );
        })}
      </AdsContainer>
    </aside>
  );
}
